import { useQuery, useMutation, useQueryClient } from 'react-query'
import {
  getChecklists,
  getOneChecklist,
  createChecklist,
  updateChecklist,
  deleteChecklist
} from '../api/checklistTools'

const getAction = (type) => {
  if (type === 'CREATE') return createChecklist
  if (type === 'UPDATE') return updateChecklist
  if (type === 'DELETE') return deleteChecklist
  return null
}

export function useChecklistsTools(page, formData, props = {}) {
  return useQuery(
    ['checkTools', page],
    () => getChecklists(page, formData),
    { enabled: false },
    {
      ...props,
      onError: (err) => {
        console.error(err.response)
      }
    }
  )
}

export function useChecklist(checkId) {
  return useQuery(['checkTool', checkId], () => getOneChecklist(checkId), {
    onError: (err) => {
      console.error(err.response)
    }
  })
}

export function useMutateChecklist(type) {
  const queryClient = useQueryClient()
  const actionFn = getAction(type)
  return useMutation(actionFn, {
    onSuccess: () => {
      queryClient.invalidateQueries('checkTools')
    },
    onError: (err) => {
      console.error(err.response)
    }
  })
}
